<template>
  <div class="pa-storybook-title-cover-wrapper">
    <transition name="story-title-modal-transition" @afterLeave="handleContentAfterLeave">
      <div class="storybook-title-content-field" v-if="isOpenContent">
        <div class="title-text title-text-story">
          <StoryTitleLogo :storyData="storyData" />
        </div>

        <div class="title-text title-text-chapter">
          <p>ー&nbsp;{{chapterTitle}}&nbsp;ー</p>
        </div>

        <div class="title-text title-text-page">
          <p>{{pageTitle}}</p>
        </div>
      </div>
    </transition>

    <transition name="story-title-modal-transition" @afterEnter="handleOverlayAfterEnter">
      <div class="storybook-title-overlay-field" v-if="isOpenOverlay"></div>
    </transition>
  </div>
</template>

<script>
import StoryTitleLogo from '@/components/Parts/StoryTitleLogo/StoryTitleLogo.vue'

import {GetStoryData, GetChapterData, GetStoryPageData} from '@/graphql/queries/Story.graphql'
// import {GetChapterData}   from '@/graphql/queries/Story.graphql'
// import {GetStoryPageData} from '@/graphql/queries/Story.graphql'

export default {
  props : {
    isOpen : {
      default: false
    }
  },

  components : {
    StoryTitleLogo
  },
  
  data(){
    return {
      isOpenContent   : false,
      isOpenOverlay   : false,

      storyTitle      : '---',
      storySlug       : '',
      chapterTitle    : '---',
      pageTitle       : '',

      storyTitleImage : 'StoryTitleLogo',

      storyTitleLogoList : {
          'prorogue' : null,
          'first'     : 'StoryTitleLogo'
      },
    }
  },

  computed : {
    hasStoryTitleLogo(){
      if(this.storyTitleImage !== null){
        return true;
      }else{
        return false;
      }
    },

    selectedStoryId(){
      return this.$store.state.storyBook.selectedStoryId;
    },

    selectedChapterId(){
      return this.$store.state.storyBook.selectedChapterId;
    },

    selectedPageId(){
      return this.$store.state.storyBook.selectedPageId;
    }
  },

  apollo : {
    storyData : {
      query : GetStoryData,
      variables(){
        return {
          id  : this.selectedStoryId
        };
      },
      skip(){
        if(this.selectedStoryId === null){
          return true;
        }else{
          return false;
        }
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    chapterData : {
      query : GetChapterData,
      variables(){
        return {
          id  : this.selectedChapterId
        };
      },
      skip(){
        if(this.selectedChapterId === null){
          return true;
        }else{
          return false;
        }
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    storyPageData : {
      query : GetStoryPageData,
      variables(){
        return {
          id  : this.selectedPageId
        };
      },
      skip(){
        if(this.selectedPageId === null){
          return true;
        }else{
          return false;
        }
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    isOpen : {
      handler(value){
        if(value === true){
          this.isOpenOverlay = true;
        }else{
          this.isOpenContent = false;
        }
      },
      immediate: true
    },

    storySlug : {
      handler(value){
        if(value === null) return;

        for(let i in this.storyTitleLogoList){
          if(value === i){
            this.storyTitleImage = this.storyTitleLogoList[i];
            return;
          }
        }

        this.storyTitleImage = null;
      },
      immediate: true
    },

    storyData : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.storyTitle = data.title;
        this.storySlug  = data.slug;
      },
      immediate: true
    },

    chapterData : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        this.chapterTitle = data.title;
      },
      immediate: true
    },

    storyPageData : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        this.pageTitle = data.title;
      },
      immediate: true
    }
  },

  methods : {
    handleOverlayAfterEnter(){
      this.isOpenContent = true;
    },

    handleContentAfterLeave(){
      this.isOpenOverlay = false;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes storybookFadeBlur
{
  0%   {
    opacity:0;
    backdrop-filter: blur(0px);
  }
  100% {
    opacity:.9;
    backdrop-filter: blur(3px);
  }
}

.story-title-modal-transition{
  &-enter-active{
    animation: storybookFadeBlur .5s;
  }

  &-leave-active{
    animation: storybookFadeBlur .5s reverse;
  }

  &-enter, &-leave-to{
    opacity:0;
    backdrop-filter: blur(0px);
  }
}

.pa-storybook-title-cover-wrapper{
  .storybook-title-content-field{
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 1002;
    padding-top:10rem;

    .title-text{
      font-size:1.2rem;
      margin-bottom:.5rem;
      color:#726446;

      &-story{
        font-size:1.6rem;
        margin-bottom: 1rem;
      }

      &-chapter{
        font-size:1.3rem;
        margin-bottom: .8rem;
      }

      // &-page{
      // }

      .pa-story-title{
        max-width:380px;
        width:85%;
        margin:0 auto;

        svg{
          .cls-1 {
            fill: #8a5a23;
          }
        }
      }
    }
  }

  .storybook-title-overlay-field{
    background-color:#fafafa;
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 1001;
    background: radial-gradient($golden-box-background 50%, $golden-box-background-darker 80%, $golden-box-background-x-darker);
  }
}
</style>